// JS Imports
import { windowIsSmallerThan, toggleDarkMode } from './helpers';
import Lenis from 'lenis';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, MorphSVGPlugin);

// Lenis initialization
const lenis = new Lenis({
  duration: 1.3,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

// Start RAF loop
requestAnimationFrame(raf);

jQuery(document).ready(function ($) {
  // Fade in animation
  gsap.utils.toArray('.fade-in-75').forEach(ele => {
    gsap.to(ele, {
      scrollTrigger: {
        trigger: ele,
        start: "top 75%"
      },
      opacity: 1,
      duration: 1.8
    });
  });

  // Animate elements with the [animate-in] attribute
  gsap.utils.toArray('[animate-in]').forEach(ele => {
    // console.log(ele);
    const animation = ele.getAttribute('animate-in');
    const animatedSpeed = ele.getAttribute('animate-speed');
    const animateDelay = ele.getAttribute('animate-delay');

    const animations = {
      animate__flip: () => {
        gsap.set(ele, { y: 100, rotation: 0 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          y: 0,
          rotation: 360,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeIn: () => {
        // gsap.set(ele, { opacity: 0 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInUp: () => {
        gsap.set(ele, { y: 100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          y: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInDown: () => {
        gsap.set(ele, { y: -100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          y: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInLeft: () => {
        gsap.set(ele, { x: -100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          x: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInRight: () => {
        gsap.set(ele, { x: 100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          x: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      }
    };

    if (animations[animation]) animations[animation]();
  });

  const icons = [
    {
      selector: '.animated-services .vacuum-icon',
      timeline: gsap.timeline({ repeat: 1, yoyo: true, paused: true })
        .to('.animated-services #vacuum-outline-start', { morphSVG: '.animated-services #vacuum-outline-end' }, 0)
        .to('.animated-services #vacuum-wheel-inner-start', { morphSVG: '.animated-services #vacuum-wheel-inner-end' }, 0)
        .to('.animated-services #vacuum-wheel-outer-start', { morphSVG: '.animated-services #vacuum-wheel-outer-end' }, 0)
        .to('.animated-services #vacuum-wheel-bg-start', { morphSVG: '.animated-services #vacuum-wheel-bg-end' }, 0)
        .to('.animated-services #vacuum-background-start', { morphSVG: '.animated-services #vacuum-background-end' }, 0)
    },
    {
      selector: '.animated-services .rabbit-icon',
      timeline: gsap.timeline({ repeat: 1, yoyo: true, paused: true })
        .to('.animated-services #rabbit-front-start', { morphSVG: '.animated-services #rabbit-front-end', duration: 0.8 }, 0)
        .to('.animated-services #rabbit-back-start', { morphSVG: '.animated-services #rabbit-back-end', duration: 0.8 }, 0)
        .to('.animated-services #rabbit-bg-start', { morphSVG: '.animated-services #rabbit-bg-end', duration: 0.8 }, 0)
    },
    {
      selector: '.animated-services .flower-icon',
      timeline: gsap.timeline({ repeat: 0, yoyo: false, paused: true })
        .to('.animated-services #flower-stingel-end', { morphSVG: '.animated-services #flower-stingel-start', ease: "power1.out", duration: 1 }, 0)
        .to('.animated-services #flower-inner-end', { morphSVG: '.animated-services #flower-inner-start', ease: "power1.out", duration: 1 }, 0)
        .to('.animated-services #flower-outline-end', { morphSVG: '.animated-services #flower-outline-start', ease: "power1.out", duration: 1 }, 0)
        .to('.animated-services #flower-bg-end', { morphSVG: '.animated-services #flower-bg-start', ease: "power1.out", duration: 1 }, 0)
        .to('.animated-services #flower-stingel-end', { morphSVG: '.animated-services #flower-stingel-end', ease: "bounce.out", duration: 2 }, 1)
        .to('.animated-services #flower-inner-end', { morphSVG: '.animated-services #flower-inner-end', ease: "bounce.out", duration: 2 }, 1)
        .to('.animated-services #flower-outline-end', { morphSVG: '.animated-services #flower-outline-end', ease: "bounce.out", duration: 2 }, 1)
        .to('.animated-services #flower-bg-end', { morphSVG: '.animated-services #flower-bg-end', ease: "bounce.out", duration: 2 }, 1)
    },
    {
      selector: '.animated-services .car-icon',
      timeline: gsap.timeline({ repeat: 0, yoyo: false, paused: true })
        .set('.animated-services #car-icon-bg, #car-outline', { opacity: 1, ease: "power1.out", y: 0, duration: 0.5 }, 0)
        .set('.animated-services #rain-drop-one, .animated-services #rain-drop-two, .animated-services #rain-drop-three', { opacity: 0, y: -10 }, 0)
        .to('.animated-services #rain-drop-one', { opacity: 1, ease: "power1.out", y: 0, duration: 0.5 }, 0)
        .to('.animated-services #rain-drop-two', { opacity: 1, ease: "power1.out", y: 0, duration: 0.5 }, 0.5)
        .to('.animated-services #rain-drop-three', { opacity: 1, ease: "power1.out", y: 0, duration: 0.5 }, 1.5)
        .to('.animated-services #car-icon-bg, #car-outline', { opacity: 1, ease: "power1.out", y: 0, duration: 0.5 }, 0)
    },
    { 
      selector: '.animated-services .box-icon', 
      timeline: gsap.timeline({ repeat: 0, paused: true })
        .to( ".animated-services #box_icon", { duration: 1.2, y: -6, ease: "power1.inOut" }, 0)
        .to( ".animated-services #box_icon", { duration: 1.2, y: 0, ease: "power1.inOut" }, 1.2)

    },
    {
      selector: '.animated-services .pool-icon',
      timeline: gsap.timeline({ repeat: 0, paused: true, duration: 1.5 })
        .to('.animated-services #waves-outline-start', { morphSVG: '.animated-services #waves-outline-end', ease: "power1.out", y: 0, duration: 1.5 }, 0)
        .to('.animated-services #waves-background-start', { morphSVG: '.animated-services #waves-background-end', ease: "power1.out", y: 0, duration: 1.5 }, 0)
        .to('.animated-services #waves-outline-start', { morphSVG: '.animated-services #waves-outline-start', ease: "power1.out", y: 0, duration: 1.5 }, 1.5)
        .to('.animated-services #waves-background-start', { morphSVG: '.animated-services #waves-background-start', ease: "power1.out", y: 0, duration: 1.5 }, 1.5)
    },
    {
      selector: '.animated-services .window-icon',
      timeline: gsap.timeline({ repeat: 0, yoyo: true, paused: true })
        .to('.animated-services #curtain-bg-start', { duration: 1, x: "-100%", ease: "power2.out"}, 0) 
        .to('.animated-services #curtain-bg-start', { duration: 1, x: "0%", ease: "power2.out"}, 1)
    },
    {
      selector: '.animated-services .washing-machine-icon',
      timeline: gsap.timeline({ repeat: 0, yoyo: false, paused: true })
        .to('.animated-services #washing-machine-door', { rotation: "360", ease: 'none', transformOrigin: "center", duration: 1.5 }, 0)
    }
  ];

  icons.forEach(icon => {
    $(icon.selector).on('mouseover', () => { 
      icon.timeline.seek(0);
      icon.timeline.play()
    });
    $(icon.selector).on('mouseout', () => {
      // 
    }); 
    
  });
});